import { trimEnd } from 'lodash-es'

import type { IResolvedHost } from '@loc/hosts/src/helpers.server'
import type { UrlObject } from 'node:url'
import type { LinkProps } from 'next/link'

export function normalizeLinkHref(
  href: LinkProps['href'],
  origin: string,
): UrlObject {
  if (typeof href === 'string') {
    // [注意] 当 href 为绝对路径时，url.origin 不生效
    const hrefUrl = new URL(href, origin)

    return {
      // auth: ''
      hash: hrefUrl.hash,
      host: hrefUrl.host,
      hostname: hrefUrl.hostname,
      href: hrefUrl.href,
      pathname: hrefUrl.pathname,
      protocol: hrefUrl.protocol,
      search: hrefUrl.search,
      // slashes: '',
      port: hrefUrl.port,
      query: hrefUrl.search,
    }
  }

  if (!href.host && !href.protocol) {
    const originUrl = new URL(origin)
    return {
      ...href,
      host: originUrl.host,
      hostname: originUrl.hostname,
      protocol: originUrl.protocol,
    }
  }

  return href
}

export function normalizeLinkHrefProps(
  urlObject: UrlObject,
  options: {
    resolvedHost: IResolvedHost
    href: LinkProps['href']
    as: LinkProps['as']
    prefixOrigin?: string
    locale?: string
    defaultLocale?: string
  },
) {
  const { href, as, prefixOrigin, locale, defaultLocale } = options

  // Link href 对应页面的 origin
  const urlObjectOrigin = `${urlObject.protocol}//${urlObject.host}`

  // 仅在站点内部超链接时做特殊处理，自定义 prefix origin 与当前页面的 origin 不同时，
  // 处理 prefixOrigin 的逻辑，使得该相对路径能跳转到 prefixOrigin 下
  if (prefixOrigin && prefixOrigin !== urlObjectOrigin) {
    const localePrefix = locale === defaultLocale ? '' : `/${locale}`
    return {
      href: `${prefixOrigin}${localePrefix}${trimEnd(
        urlObject.pathname || '',
        '/',
      )}${urlObject.search}${urlObject.hash}`,
      as,
    }
  }

  return {
    href,
    as,
    locale,
  }
}
